import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MainTitle from 'base/components/MainTitle/index';
import FieldWrapper from 'base/components/forms/FieldWrapper';
import Title3 from 'base/components/Title3/index';
import { deleteTag } from 'documents/store/tags/actions';
import { getActiveTag } from 'documents/store/tags/selectors';
import { closeModal } from 'modal/store/actions';
import Button from 'base/components/Button/index';
import Col from 'base/components/Col/index';
import Row from 'base/components/Row/index';

const DeleteTagModal = ({
  name, closeModal, tag, deleteTag,
}) => (
  <>
    <MainTitle withSpaceBelow>Delete Tag</MainTitle>

    <FieldWrapper>
        Do you really want to delete
      <Title3>{tag && tag.name}</Title3>
    </FieldWrapper>

    <Row>
      <Col>
        <Button isFullWidth variant="secondary" onClick={() => closeModal(name)}>No, cancel</Button>
      </Col>
      <Col>
        <Button
          isFullWidth
          variant="primary"
          onClick={() => { closeModal(name); deleteTag(tag); }}
        >
            Yes, delete
        </Button>
      </Col>
    </Row>
  </>
);
DeleteTagModal.propTypes = {
  name: PropTypes.string.isRequired,
  tag: PropTypes.object.isRequired, // eslint-disable-line
  closeModal: PropTypes.func.isRequired,
  deleteTag: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  tag: getActiveTag(state),
});

const mapDispatchToProps = {
  deleteTag,
  closeModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeleteTagModal);
